import getConfig from "next/config";

import Button from "@components/Button";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const PhoneBuyBackHeader = ({ onBuyBackSimlationClick }) => (
  <div className="md:container">
    <div className="flex mb-[35px] sm:gap-[40px] md:mb-0 lg:mx-auto lg:max-w-[90%]">
      <div className="min-w-[60%]">
        <h1 className="text-[#979797] italic font-medium sm:text-[24px] sm:mb-[10px] lg:mb-[20px]">
          Buy Back Telefoane
        </h1>

        <div className="text-[30px] font-bold leading-[34px] sm:text-[38px] sm:leading-[40px] lg:text-[56px] lg:leading-[60px] sm:mb-[20px] lg:mb-[40px]">
          Schimba telefonul pe care il ai cu cel pe care il doresti.
        </div>

        <p className="hidden sm:block mb-[30px] text-[14px] lg:mb-[50px]">
          Iti ia doar cateva secunde sa afli cat poti primi pe vechiul tau
          telefon, apoi te asteptam in magazin pentru oferta finala
        </p>

        <div className="hidden sm:block">
          <Button
            title="Vezi estimare de buy back"
            variant="secondary"
            size="small"
            onClick={onBuyBackSimlationClick}
          />
        </div>
      </div>

      <div className="flex items-center overflow-y-clip">
        <img
          className="scale-[1.2] sm:scale-100 md:scale-[0.8] lg:scale-100 aspect-square ml-[20px] sm:ml-0"
          src={`${settings.websiteStatics}/images/buy-back/buyBack_header.png`}
          alt=""
        />
      </div>
    </div>

    <p className="sm:hidden mb-[30px] text-[14px]">
      Iti ia doar cateva secunde sa afli cat poti primi pe vechiul tau telefon,
      apoi te asteptam in magazin pentru oferta finala
    </p>

    <div className="sm:hidden">
      <Button
        title="Vezi estimare de buy back"
        variant="secondary"
        size="small"
        display="block"
        onClick={onBuyBackSimlationClick}
      />
    </div>
  </div>
);

export default PhoneBuyBackHeader;
